import { createContext, useContext, useEffect, useState } from "react";
import api, { setAuthToken, getAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const token = getAuthToken();
        if (!token) {
            setUser(false);
            setReady(true);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                setAuthToken(null);
                setUser(false);
            })
            .finally(() => setReady(true));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setAuthToken(data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        setAuthToken(null);
        setUser(false);
    };

    return <AuthContext.Provider value={{ user, ready, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
